import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { TRANSACTION_EVENT_TYPE, SPOT_CHECK_STATUS } from './TransactionList';
import TransactionRecentScrollButton from '../../../assets/images/transaction/transactionRecentScrollButton.svg'
import { ActionsDropdownForGroup } from '../../../components/base/ActionsDropdown';
import CountSelectedComponent from '../../../components/base/CountSelectedComponent';
import { PermissionCodes } from '../../../config/PermissionCodes';
import TransactionBulkActionPrompt from '../../../components/transactions/TransactionBulkActionPrompt'
import { createAction } from '../../../utils';

function CardHeader({ item, onCheckboxChange, isSelected, isDisplayCheckbox, isCheckboxDisabled, isSpotCheck }) {
    let showCheckbox = false 
    let headerColor = { displayEventType: TRANSACTION_EVENT_TYPE.TYPE_WAITING, background: '#E6F2FF', color: '#6AB3FF'}
    if (item.offlineEventType === 'APPROVED') {
        headerColor = { displayEventType: TRANSACTION_EVENT_TYPE.TYPE_APPROVED, background: '#DFFEED', color: '#02432C' }
        showCheckbox = true;
    } else if (item.offlineEventType === 'REJECTED') {
        headerColor = { displayEventType: TRANSACTION_EVENT_TYPE.TYPE_REJECTED, background: '#FFE6E1', color: '#FF6B4A' }
    } else if (item.offlineEventType === 'RECALLED') {
        headerColor = { displayEventType: TRANSACTION_EVENT_TYPE.TYPE_RECALLED, background: '#FFE6E1', color: '#FF6B4A' }
    } else if (item.offlineEventType === 'WAITING_FOR_APPROVAL') {
        showCheckbox = true;
    }

    let headerSpotCheckColor = {}
    if(isSpotCheck) {
        showCheckbox = false
        headerSpotCheckColor = { background: '#DFDFDF',  color: '#4D5560'}

        if (item.spotCheckStatus === '' && item.offlineEventType  === 'APPROVED'){
            showCheckbox = true;
        }

        if (item.spotCheckStatus === 'Pending' && item.offlineEventType  === 'APPROVED'){
            headerSpotCheckColor = { displayEventType: SPOT_CHECK_STATUS.PENDING, background: '#DFDFDF',  color: '#4D5560'}
            showCheckbox = true;
        }
    
        if (item.spotCheckStatus === 'Passed') {
            headerSpotCheckColor = { displayEventType: SPOT_CHECK_STATUS.PASSED,  background: '#94F0BE',  color: '#094E36'}
            showCheckbox = true;
        }
        if (item.spotCheckStatus === 'Recalled') {
            headerSpotCheckColor = { displayEventType: SPOT_CHECK_STATUS.RECALLED, background: '#FFCABF', color: '#FF4D26'}
        }
    }

    if (!isDisplayCheckbox) {
        showCheckbox = false
    }

    return <div className={`recent-transaction-card-header ${isSpotCheck ? 'spot-check' : ''}`} style={{ background: headerColor.background }}>
        <div className="header-top-row">
            <div>
                <label>
                    ID: {item.pk}
                </label>
                { showCheckbox  ? (
                    <input
                        disabled={isCheckboxDisabled}
                        className="transaction-card-checkbox"
                        checked={isSelected}
                        type="checkbox"
                        onChange={(e) => onCheckboxChange(item, e.target.checked)}
                        id={`checkbox-${item.pk}`}
                        style={{ opacity: isCheckboxDisabled ? 0.5 : 1 }}
                    />
                ) : <></>
                }
                <label>{item.transactionDetailDisplayDate}</label>
            </div>
        </div>
        <div className='header-bottom-row'>
            <label style={{ color: headerColor.color }}>
                {headerColor.displayEventType}
            </label>
            {
                isSpotCheck ? <label className="spot-check-label" style={{color: headerSpotCheckColor.color, backgroundColor: headerSpotCheckColor.background}}>Spot check: {headerSpotCheckColor.displayEventType}</label>
                : <></>
            }
        </div>
    </div>
}

function CardRecyclableItem({ recycleItem }) {
    return <label className='recent-transaction-item-recyclable'>
        {recycleItem?.node?.name}({recycleItem?.node?.quantity})
    </label>
}

function CardBody({ item }) {

    return <div className="recent-transaction-item-body">
        <div>
            <label>Recyclable</label>
            {item.photoTakingItems?.edges?.map((photoItem, index) => (<CardRecyclableItem key={`{${photoItem.node?.pk || index}}`} recycleItem={photoItem} />))}
        </div>
        <img src={item.receiptImage} />
    </div>
}

function CardBottom({ item }) {
    return <div className='recent-transaction-card-bottom'>
        <label>Total Amount</label>
        <label>{item?.totalRewardAmount}</label>
    </div>
}

export function TransactionCard({ item, onCheckboxChange, isSelected, isDisplayCheckbox, isCheckboxDisabled, isSpotCheck }) {
    return <div className='recent-transaction-item' >
        <CardHeader item={item} onCheckboxChange={onCheckboxChange} isSelected={isSelected} isDisplayCheckbox={isDisplayCheckbox} isCheckboxDisabled={isCheckboxDisabled} isSpotCheck={isSpotCheck}/>
        <CardBody item={item} />
        <CardBottom item={item} />
    </div>
}

export function RecentTransactions({ isSpotCheck, recentTransactions, hasNext, dispatch, currentTransactionId, currentUserId }) {
    const [selectedApprovedTransactions, setSelectedApprovedTransactions] = useState([]);
    const [selectedWaitingTransactions, setSelectedWaitingTransactions] = useState([]);
    const [selectedSpotCheckPendingTransactions, setSelectedSpotCheckPendingTransactions] = useState([]);
    const [hasRecall, setHasRecall] = useState(false);
    const [hasApprove, setHasApprove] = useState(false);
    const [hasSpotCheckPass, setHasSpotCheckPass] = useState(false);
    const [showActionPrompt, setShowActionPrompt] = useState(false);
    const [promptActionTitle, setPromptActionTitle] = useState();
    const [recalledReason, setRecalledReason] = useState({ value: null, label: null });

    const handleCheckboxChange = (transaction, isChecked) => {
        const isApproved = transaction.offlineEventType === 'APPROVED';
        const isWaiting = transaction.offlineEventType === 'WAITING_FOR_APPROVAL';
        const isSpotCheckPending = isSpotCheck && isApproved && transaction.spotCheckStatus === 'Pending';
        const isSpotCheckPassed = isSpotCheck && isApproved && (transaction.spotCheckStatus === 'Passed' || transaction.spotCheckStatus==='');
        
        if (isSpotCheckPending) {
            setSelectedSpotCheckPendingTransactions(prev => {
                // If trying to select and already at 10 items, don't add
                if (isChecked && prev.length >= 10) {
                    return prev;
                }
                
                const newSelected = isChecked
                    ? [...prev, transaction]
                    : prev.filter(prevTran => prevTran.pk !== transaction.pk);
                
                setHasSpotCheckPass(newSelected.length > 0);
                
                // Clear passed transactions when selecting pending (mutual exclusivity in spot check)
                if (isChecked && newSelected.length === 1) {
                    setSelectedApprovedTransactions([]);
                    setSelectedWaitingTransactions([]);
                    setHasRecall(false);
                    setHasApprove(false);
                }
                
                return newSelected;
            });
        } else if (isSpotCheckPassed) {
            setSelectedApprovedTransactions(prev => {
                // If trying to select and already at 10 items, don't add
                if (isChecked && prev.length >= 10) {
                    return prev;
                }
                
                const newSelected = isChecked
                    ? [...prev, transaction]
                    : prev.filter(prevTran => prevTran.pk !== transaction.pk);
                
                setHasRecall(newSelected.length > 0);
                
                // Clear pending transactions when selecting passed (mutual exclusivity in spot check)
                if (isChecked && newSelected.length === 1) {
                    setSelectedSpotCheckPendingTransactions([]);
                    setSelectedWaitingTransactions([]);
                    setHasSpotCheckPass(false);
                    setHasApprove(false);
                }
                
                return newSelected;
            });
        } else if (isApproved && !isSpotCheck) {
            setSelectedApprovedTransactions(prev => {
                // If trying to select and already at 10 items, don't add
                if (isChecked && prev.length >= 10) {
                    return prev;
                }
                
                const newSelected = isChecked
                    ? [...prev, transaction]
                    : prev.filter(prevTran => prevTran.pk !== transaction.pk);
                
                setHasRecall(newSelected.length > 0);
                
                // Clear other selections when selecting approved
                if (isChecked && newSelected.length === 1) {
                    setSelectedWaitingTransactions([]);
                    setHasApprove(false);
                }
                
                return newSelected;
            });
        } else if (isWaiting && !isSpotCheck) {
            setSelectedWaitingTransactions(prev => {
                // If trying to select and already at 10 items, don't add
                if (isChecked && prev.length >= 10) {
                    return prev;
                }
                
                const newSelected = isChecked
                    ? [...prev, transaction]
                    : prev.filter(prevTran => prevTran.pk !== transaction.pk);
                
                setHasApprove(newSelected.length > 0);
                
                // Clear other selections when selecting waiting
                if (isChecked && newSelected.length === 1) {
                    setSelectedApprovedTransactions([]);
                    setHasRecall(false);
                }
                
                return newSelected;
            });
        }
    };

    const setActionPrompt = (event, item) => {
        setPromptActionTitle(event);
        setShowActionPrompt(true);
    };

    const groupActions = isSpotCheck ? [
        {
          name: 'Pass',
          action: () => {
            setActionPrompt('pass', selectedSpotCheckPendingTransactions)
          },
          requires: PermissionCodes.changeTransaction,
          disabled: !hasSpotCheckPass
        },
        {
          name: 'Recall',
          action: () => {
            // Use pending transactions if they are selected, otherwise use approved (passed) transactions
            const transactionsToRecall = selectedSpotCheckPendingTransactions.length > 0
              ? selectedSpotCheckPendingTransactions
              : selectedApprovedTransactions;
            setActionPrompt('recall', transactionsToRecall)
          },
          requires: PermissionCodes.changeTransaction,
          disabled: !hasRecall && !hasSpotCheckPass
        },
        {
            name: 'Recall with message',
            action: () => {
              // Use pending transactions if they are selected, otherwise use approved (passed) transactions
              const transactionsToRecall = selectedSpotCheckPendingTransactions.length > 0
                ? selectedSpotCheckPendingTransactions
                : selectedApprovedTransactions;
              setActionPrompt('recall_with_reason', transactionsToRecall)
            },
            requires: PermissionCodes.changeTransaction,
            disabled: !hasRecall && !hasSpotCheckPass
        },
    ] : [
        {
          name: 'Approve',
          action: () => {
            setActionPrompt('approve', selectedWaitingTransactions)
          },
          requires: PermissionCodes.changeTransaction,
          disabled: !hasApprove
        },
        {
          name: 'Recall',
          action: () => {
            setActionPrompt('recall', selectedApprovedTransactions)
          },
          requires: PermissionCodes.changeTransaction,
          disabled: !hasRecall
        },
        {
            name: 'Recall with message',
            action: () => {
              setActionPrompt('recall_with_reason', selectedApprovedTransactions)
            },
            requires: PermissionCodes.changeTransaction,
            disabled: !hasRecall
        },
    ];


    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [showLeftButton, setShowLeftButton] = useState(false);
    const [showRightButton, setShowRightButton] = useState(false);
    const scrollAreaRef = useRef(null);

    useEffect(() => {
        setPage(1);
    }, [currentUserId]);

     // Initialize and update scroll buttons visibility
     useEffect(() => {
        if (!scrollAreaRef.current) return;

        const updateButtonsVisibility = () => {
            const scrollArea = scrollAreaRef.current;
            if (!scrollArea) return;

            const isAtEnd = scrollArea.scrollWidth - (scrollArea.scrollLeft + scrollArea.clientWidth) < 10;
            const isAtStart = scrollArea.scrollLeft < 10;

            setShowLeftButton(recentTransactions.length >= 5 && !isAtStart);
            setShowRightButton(recentTransactions.length >= 5 && (!isAtEnd || hasNext));
        };

        // Add scroll event listener
        const scrollArea = scrollAreaRef.current;
        scrollArea.addEventListener('scroll', updateButtonsVisibility);
        
        // Initial check
        updateButtonsVisibility();

        // Cleanup
        return () => {
            if (scrollArea) {
                scrollArea.removeEventListener('scroll', updateButtonsVisibility);
            }
        };
    }, [recentTransactions, hasNext, scrollAreaRef.current]);

    if (!recentTransactions || recentTransactions.length < 1) {
        return null;
    }

    const refreshTransactions = async () => {
        try {
            setPage(1); // Reset page to 1
            await dispatch({
                type: 'transactions/getRecentTransactions',
                payload: {
                    uid: currentUserId,
                    id: currentTransactionId,
                    page: 1
                }
            });
        } catch (error) {
            console.error('Error refreshing transactions:', error);
        }
    };

    const handleRecallAction = async () => {
        try {
            const actionCreator = createAction('transactions/bulkRecallTransaction');
            
            // Use pending transactions if they are selected, otherwise use approved transactions
            const transactionsToRecall = selectedSpotCheckPendingTransactions.length > 0
                ? selectedSpotCheckPendingTransactions
                : selectedApprovedTransactions;
            
            const action = actionCreator({
                transactions: transactionsToRecall.map((transaction) => transaction.pk),
                afterActions: () => {
                    dispatch({
                        type: 'transactions/getRecentTransactions',
                        payload: {
                            uid: currentUserId,
                            id: currentTransactionId,
                            page: 1
                        }
                    });
                    
                    // Clear the appropriate selection based on which type was recalled
                    if (selectedSpotCheckPendingTransactions.length > 0) {
                        setSelectedSpotCheckPendingTransactions([]);
                        setHasSpotCheckPass(false);
                    } else {
                        setSelectedApprovedTransactions([]);
                        setHasRecall(false);
                    }
                },
                ...(promptActionTitle === 'recall_with_reason'
                    ? {
                        recalledReason: recalledReason,
                        isSpotCheck: isSpotCheck
                    }
                    : { isSpotCheck: isSpotCheck }
                ),
            });
            
            return dispatch(action);
        } catch (error) {
            console.error('Recall action error:', error);
            return { error: "Failed to recall transactions" };
        }
    };

    const handleApproveAction = async () => {
        try {
            const actionCreator = createAction('transactions/bulkApproveTransaction');
            const action = actionCreator({
                transactions: selectedWaitingTransactions.map((transaction) => transaction.pk),
                afterActions: () => {
                    dispatch({
                        type: 'transactions/getRecentTransactions',
                        payload: {
                            uid: currentUserId,
                            id: currentTransactionId,
                            page: 1
                        }
                    });
                    setSelectedWaitingTransactions([]);
                    setHasApprove(false);
                },
                isSpotCheck: isSpotCheck
            });
            
            return dispatch(action);
        } catch (error) {
            return { error: "Failed to approve transactions" };
        }
    };

    const handleSpotCheckPassAction = async () => {      
        try {
            const actionCreator = createAction('transactions/bulkPassSpotCheck');
            const action = actionCreator({
                transactions: selectedSpotCheckPendingTransactions.map((transaction) => transaction.pk),
                afterActions: () => {
                    dispatch({
                        type: 'transactions/getRecentTransactions',
                        payload: {
                            uid: currentUserId,
                            id: currentTransactionId,
                            page: 1
                        }
                    });
                    setSelectedSpotCheckPendingTransactions([]);
                    setHasSpotCheckPass(false);
                },
                isSpotCheck: isSpotCheck
            });
            
            return dispatch(action);
        } catch (error) {
            console.error('Spot check pass action error:', error);
            return { error: "Failed to pass spot check transactions" };
        }
    };
      
    const handleScroll = async (isScrollLeft) => {
        if (!scrollAreaRef.current) {
            console.error('Scroll area ref is null');
            return;
        }

        const scrollArea = scrollAreaRef.current;
        if (!scrollArea) return;

        const containerLeft = scrollArea.scrollLeft;
        const scrollWidth = scrollArea.scrollWidth;
        const clientWidth = scrollArea.clientWidth;
        const changedPosition = isScrollLeft ? -388 : 388;

        // If scrolling right and near the end, fetch more data
        if (!isScrollLeft && 
            scrollWidth - (containerLeft + clientWidth) < 200 && 
            !isLoading && 
            hasNext) {
            try {
                setIsLoading(true);
                await dispatch({
                    type: 'transactions/getRecentTransactions',
                    payload: {
                        uid: currentUserId,
                        id: currentTransactionId,
                        page: page + 1
                    }
                });
                setPage(prev => prev + 1);
            } finally {
                setIsLoading(false);
            }
        }

        // Perform the scroll
        scrollArea.scrollTo({
            left: containerLeft + changedPosition,
            behavior: 'smooth'
        });
    };

    
    const handleScrollVisibility = () => {
        // Force re-render to update button visibility
        setIsLoading(prev => prev);
    };

    return (
        <div className="create-section-and-preview-container row recent-transaction-container">
            <div>
                <label>RECENT TRANSACTION FROM THE SAME USER</label>
                <div className="all-list-component-action-header-div">
                    {groupActions?.length > 0 ? (
                    <ActionsDropdownForGroup actions={groupActions}/>
                    ) : null}
                    <CountSelectedComponent
                    total={selectedApprovedTransactions.length + selectedWaitingTransactions.length + selectedSpotCheckPendingTransactions.length}
                    />
                    {(selectedApprovedTransactions.length >= 10 || selectedWaitingTransactions.length >= 10 || selectedSpotCheckPendingTransactions.length >= 10) && (
                        <div className="select-maximum-msg">
                            Maximum 10 transactions can be selected
                        </div>
                    )}
                </div>
                <div 
                    ref={scrollAreaRef}
                    id="recent-transaction-scroll" 
                    className='recent-transaction-items'
                    onScroll={handleScrollVisibility}
                >
                    {recentTransactions.map((item, index) => {
                        const isApproved = item.offlineEventType === 'APPROVED';
                        const isWaiting = item.offlineEventType === 'WAITING_FOR_APPROVAL';
                        const isSpotCheckPending = isSpotCheck && isApproved && item.spotCheckStatus === 'Pending';
                        const isSpotCheckPassed = isSpotCheck && isApproved && (item.spotCheckStatus === 'Passed' || item.spotCheckStatus === '') ;
                        
                        let isSelected = false;
                        if (isSpotCheckPending) {
                            isSelected = selectedSpotCheckPendingTransactions.includes(item);
                        } else if (isSpotCheckPassed || (isApproved && !isSpotCheck)) {
                            isSelected = selectedApprovedTransactions.includes(item);
                        } else if (isWaiting && !isSpotCheck) {
                            isSelected = selectedWaitingTransactions.includes(item);
                        }
                        
                        // Hide checkboxes for opposite type when one type is selected
                        const shouldShowCheckbox = () => {
                            if (isSpotCheck) {
                                // In spot check mode, hide checkboxes for opposite spot check type when one is selected
                                if (selectedApprovedTransactions.length > 0 && isSpotCheckPending) return false;
                                if (selectedSpotCheckPendingTransactions.length > 0 && isSpotCheckPassed) return false;
                                return true;
                            } else {
                                // In regular mode, hide checkboxes for opposite type when one is selected
                                if (selectedApprovedTransactions.length > 0 && isWaiting) return false;
                                if (selectedWaitingTransactions.length > 0 && isApproved) return false;
                                return true;
                            }
                        };
                        
                        let isCheckboxDisabled = false;
                        if (isSpotCheckPending) {
                            isCheckboxDisabled = selectedSpotCheckPendingTransactions.length >= 10 && !selectedSpotCheckPendingTransactions.includes(item);
                        } else if (isSpotCheckPassed || (isApproved && !isSpotCheck)) {
                            isCheckboxDisabled = selectedApprovedTransactions.length >= 10 && !selectedApprovedTransactions.includes(item);
                        } else if (isWaiting && !isSpotCheck) {
                            isCheckboxDisabled = selectedWaitingTransactions.length >= 10 && !selectedWaitingTransactions.includes(item);
                        }
                        
                        return (
                            <TransactionCard
                                key={index}
                                item={item}
                                onCheckboxChange={handleCheckboxChange}
                                isSelected={isSelected}
                                isDisplayCheckbox={shouldShowCheckbox()}
                                isSpotCheck={isSpotCheck}
                                isCheckboxDisabled={isCheckboxDisabled}
                            />
                        );
                    })}
                    {isLoading && (
                        <div className="recent-transaction-loading">
                            Loading...
                        </div>
                    )}
                </div>
                {showLeftButton && (
                    <img 
                        id='recent-transaction-scroll-to-left'
                        className="scroll-left-button" 
                        src={TransactionRecentScrollButton} 
                        onClick={() => handleScroll(true)}
                    />
                )}
                {showRightButton && (
                    <img 
                        id="recent-transaction-scroll-to-right"
                        className="scroll-right-button" 
                        src={TransactionRecentScrollButton} 
                        onClick={() => handleScroll(false)}
                    />
                )}
            </div>
            <TransactionBulkActionPrompt
                event={promptActionTitle}
                items={
                    promptActionTitle === 'approve' ? selectedWaitingTransactions :
                    promptActionTitle === 'pass' ? selectedSpotCheckPendingTransactions :
                    (promptActionTitle === 'recall' || promptActionTitle === 'recall_with_reason') && selectedSpotCheckPendingTransactions.length > 0 ? selectedSpotCheckPendingTransactions :
                    selectedApprovedTransactions
                }
                show={showActionPrompt}
                recalledReason={recalledReason}
                refreshTransactions={refreshTransactions}
                onHide={() => {
                    setShowActionPrompt(false);
                }}
                action={async () => {
                    const response =
                        promptActionTitle === 'approve' ? await handleApproveAction() :
                        promptActionTitle === 'pass' ? await handleSpotCheckPassAction() :
                        await handleRecallAction();
                    return response;
                }}
                setRecalledReason={setRecalledReason}
                isSpotCheck={isSpotCheck}
            />
        </div>
    );
}

const mapStateToProps = (state) => ({
    recentTransactions: state.transactions.recentTransactions,
    currentTransactionId: state.transactions.selectedTransaction?.pk,
    currentUserId: state.transactions.selectedTransaction?.ssoUid,
    hasNext: state.transactions.hasNextRecentTransactions, 
});


export default connect(mapStateToProps)(RecentTransactions);
